exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-primary-pink{background-color:#f8264d!important}.bg-primary-violet{background-color:#7a00ff!important}@media only screen and (min-width:768px){.cv-head{padding-left:190px;position:relative;margin-bottom:50px}.cv-head .profile-image{position:absolute;left:0;height:160px}}.cv-head .profile-image{display:block;margin:0 auto 30px}.cv-head h4{color:#f8264d}#about .experience-block{margin-bottom:30px}#about .experience-block h4{margin-bottom:0}#about .experience-block .timestamp{color:#f8264d;margin-bottom:6px}#about .experience-block .location{color:#666}#about ol{padding-left:30px;padding-top:20px;margin-top:10px;border-top:1px solid #c3c3c3}#about .list-keywords li{display:inline-block;background-color:#3c3c3c;color:#fff;font-weight:600;font-size:1.3rem;padding:3px 8px;margin:0 6px 8px 0;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/About.less
// module id = 310
// module chunks = 0